// extracted by mini-css-extract-plugin
module.exports = {"image":"postHero-module--image--3XgFx","title":"postHero-module--title--34JUZ","info":"postHero-module--info--1PtyM"};